// Entry для site_newgen pack.
// 1. Создаёт RootStore (с AuthStore — bootstrap MobileToken через v3 API).
// 2. Монтирует React-компоненты в DOM по `[data-react="..."]` точкам.
// 3. Принципиально не зависит от website_default — newgen едет на v3 API.

import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { getRootStore } from '../stores/rootStore';
import { StoresProvider } from '../shared/observer';
import { initImgLoad } from '../shared/imgLoad';
import { installWA, drainWAQ, closeMobileMenu, toggleMobileMenu } from '../wa/index';
import { LoginButton } from '../components/Auth/LoginButton';
import { LoginDialog } from '../components/Auth/LoginDialog';
import { ToCart } from '../components/Cart/ToCart';
import { HeroOrderButton } from '../components/Cart/HeroOrderButton';
import { HeaderCart } from '../components/Cart/HeaderCart';
import { HeaderOrders } from '../components/Profile/HeaderOrders';
import { CartApp } from '../components/Cart/CartApp';
import { ProfileApp } from '../components/Profile/ProfileApp';
import { ClientInfoDialog } from '../components/Profile/ClientInfoDialog';
import { AddAddressDialog } from '../components/Address/AddAddressDialog';
import { FastOrderForm } from '../components/Pages/FastOrderForm';
import { CityBranchDialog } from '../components/CityBranch/CityBranchDialog';
import { CityBranchButton } from '../components/CityBranch/CityBranchButton';
import { CookieConsentBanner } from '../components/Cookie/CookieConsentBanner';

const components = {
  LoginButton,
  LoginDialog,
  ToCart,
  HeroOrderButton,
  HeaderCart,
  HeaderOrders,
  CartApp,
  ProfileApp,
  ClientInfoDialog,
  AddAddressDialog,
  FastOrderForm,
  CityBranchDialog,
  CityBranchButton,
  CookieConsentBanner,
};

function mountNode(node, rootStore) {
  const name = node.getAttribute('data-react');
  const Cmp = components[name];
  if (!Cmp) return; // компонент пока не реализован — это ок на ранних этапах
  let params = {};
  try { params = JSON.parse(node.getAttribute('data-params') || '{}'); } catch (e) { /* noop */ }
  node.__waMounted = true;
  ReactDOM.render(
    React.createElement(
      StoresProvider,
      { rootStore },
      React.createElement(Cmp, { params }),
    ),
    node,
  );
}

// Монтирует [data-react]-узлы внутри container (для WA.ui.mount — в т.ч.
// динамически вставленный MCP-HTML). Повторный вызов узлы не перемонтирует.
function mountIn(container, rootStore) {
  const nodes = (container || document).querySelectorAll('[data-react]');
  nodes.forEach((node) => {
    if (node.__waMounted) return;
    mountNode(node, rootStore);
  });
}

function mountAll(rootStore) {
  mountIn(document, rootStore);
}

// Toggle мобильного меню — клик по любой `.mobile-menu-button` (бургер
// или крестик ×) переключает .active на #mobile-menu. Аналог
// `initMobileMenuToggle` из website_default/js/initializers/main_page.js,
// но на ванильном JS (без jQuery).
function initMobileMenuToggle() {
  document.addEventListener('click', (e) => {
    // Бургер/крестик — toggle меню
    const btn = e.target.closest('.mobile-menu-button');
    if (btn) {
      e.preventDefault();
      toggleMobileMenu();
      return;
    }
    // Клик «Войти» внутри мобильного меню — закрываем меню и
    // открываем LoginDialog (как в шапке).
    const loginA = e.target.closest('.ng-mobile-menu__login');
    if (loginA) {
      e.preventDefault();
      closeMobileMenu();
      const rs = window.__rootStore;
      if (rs && rs.authStore) rs.authStore.setLoginDialogOpen(true);
      return;
    }
    // Клик по любому пункту меню — просто закрываем (после перехода).
    const link = e.target.closest('#mobile-menu a');
    if (link) {
      closeMobileMenu();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initImgLoad(); // спиннеры/фейд контентных картинок (.ng-img) — до монтирования React
  initMobileMenuToggle();
  const rootStore = getRootStore();
  if (typeof window !== 'undefined') window.__rootStore = rootStore; // debug
  // Публичный JS API для MCP-HTML: window.WA + очередь window.WAQ
  // (см. js/wa/index.js). Очередь разбираем сразу — MCP-скрипты успели
  // напушить колбэки ещё до загрузки пака. Любой сбой WA не должен
  // помешать монтированию React-компонентов самого сайта.
  let markReady = () => {};
  try {
    const wa = installWA(rootStore, (container) => mountIn(container, rootStore));
    window.WA = wa.WA;
    drainWAQ(wa.WA);
    markReady = () => {
      try { wa.markReady(); } catch (e) { console.error('[WA] markReady failed', e); }
    };
  } catch (e) {
    console.error('[WA] install failed', e);
  }
  rootStore.bootstrap().then(() => {
    mountAll(rootStore);
    markReady();
  }, (err) => {
    console.error('[newgen] bootstrap failed', err);
    // Всё равно монтируем компоненты — они отрисуются на пустом сторе и
    // обновятся, как только пользователь повторит действие.
    mountAll(rootStore);
    markReady();
  });
});



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/react/initializer.js